import { render } from "./AudioFolderModal.vue?vue&type=template&id=cae0bf42&scoped=true"
import script from "./AudioFolderModal.vue?vue&type=script&lang=js"
export * from "./AudioFolderModal.vue?vue&type=script&lang=js"

import "./AudioFolderModal.vue?vue&type=style&index=0&id=cae0bf42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae0bf42"]])

export default __exports__